<template>
  <div class="header" :class="{ 'header-fixed': fixed }">
    <div class="header-content">
      <div class="logo-area" @click="goHome">
        <img v-if="systemLogo" :src="systemLogo" class="logo-img" alt="Logo" />
        <span v-else class="logo">LOGO</span>
        <span v-if="systemName" class="system-name">{{ systemName }}</span>
      </div>
      <div v-if="isLoggedIn" class="user-area" ref="userArea">
        <div class="user-info" @click="showUserMenu = !showUserMenu">
          <img :src="userAvatar" class="avatar" />
          <span class="user-email">{{ userInfo.email || userInfo.userName }}</span>
        </div>
        <div v-if="showUserMenu" class="user-menu">
          <div class="menu-header">
            <img :src="userAvatar" class="menu-avatar" />
            <span class="menu-nickname">{{ userInfo.email || userInfo.userName }}</span>
          </div>
          <div class="menu-divider"></div>
          <div class="menu-actions">
            <div class="menu-item" @click="goProfile">
              <img src="@/assets/image/geren.png" class="menu-icon" />
              <span>个人信息</span>
            </div>
            <div class="menu-item" @click="goFavorite">
              <img src="@/assets/image/shoucang.png" class="menu-icon" />
              <span>收藏</span>
            </div>
            <div class="menu-item" @click="goExamRecord">
              <img src="@/assets/image/kaoshi.png" class="menu-icon" />
              <span>考试</span>
            </div>
          </div>
          <div class="menu-logout" @click="handleLogout">
            <span>退出</span>
            <img src="@/assets/image/quit.png" class="logout-icon" />
          </div>
        </div>
      </div>
      <button v-else class="login-btn" @click="goLogin">登录</button>
    </div>
  </div>
</template>

<script>
import config from '@/utils/config'
import { getSystemConfig } from '@/api/systemConfig'

export default {
  name: 'TopHeader',
  props: {
    fixed: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      userInfo: null,
      showUserMenu: false,
      systemLogo: '',
      systemName: ''
    }
  },
  computed: {
    isLoggedIn() {
      return this.userInfo !== null
    },
    userAvatar() {
      if (this.userInfo && this.userInfo.avatar) {
        if (this.userInfo.avatar.startsWith('http')) {
          return this.userInfo.avatar
        }
        return config.imageBaseURL + this.userInfo.avatar
      }
      return require('@/assets/image/touxiang.png')
    }
  },
  created() {
    const stored = localStorage.getItem('userInfo')
    if (stored) {
      this.userInfo = JSON.parse(stored)
    }
    this.loadSystemConfig()
    // 点击页面任意位置关闭菜单
    document.addEventListener('click', this.handleClickOutside)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside)
  },
  methods: {
    async loadSystemConfig() {
      try {
        const res = await getSystemConfig()
        if (res.data) {
          this.systemLogo = res.data.systemLogo || ''
          this.systemName = res.data.systemName || ''
        }
      } catch (error) {
        console.error('获取系统配置失败', error)
      }
    },
    handleClickOutside(e) {
      // 如果点击的不是用户区域，关闭菜单
      if (this.showUserMenu && this.$refs.userArea && !this.$refs.userArea.contains(e.target)) {
        this.showUserMenu = false
      }
    },
    goHome() {
      this.$router.push('/home')
    },
    goLogin() {
      this.$router.push('/login')
    },
    goProfile() {
      this.showUserMenu = false
      if (this.$route.path !== '/profile') {
        this.$router.push('/profile')
      }
    },
    goFavorite() {
      this.showUserMenu = false
      if (this.$route.path !== '/favorite') {
        this.$router.push('/favorite')
      }
    },
    goExamRecord() {
      this.showUserMenu = false
      if (this.$route.path !== '/exam-record') {
        this.$router.push('/exam-record')
      }
    },
    handleLogout() {
      localStorage.removeItem('userInfo')
      localStorage.removeItem('token')
      this.userInfo = null
      this.showUserMenu = false
      this.$router.push('/login')
    }
  }
}
</script>

<style scoped>
.header {
  background: #fff;
  z-index: 1000;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
}
.header-fixed {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
}
.header-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 10px 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.logo-area {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
}
.logo {
  color: #3d8c40;
  font-size: 20px;
  font-weight: bold;
}
.logo-img {
  width: 36px;
  height: 36px;
  border-radius: 6px;
  object-fit: contain;
}
.system-name {
  color: #3d8c40;
  font-size: 18px;
  font-weight: 600;
}
.user-area {
  position: relative;
}
.user-info {
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
}
.avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  object-fit: cover;
}
.user-email {
  font-size: 14px;
  color: #333;
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.user-menu {
  position: absolute;
  top: 45px;
  right: 0;
  width: 220px;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  z-index: 100;
  overflow: hidden;
}
.menu-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 15px;
}
.menu-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  object-fit: cover;
}
.menu-nickname {
  font-size: 14px;
  color: #333;
  font-weight: 500;
}
.menu-divider {
  height: 1px;
  background: #eee;
  margin: 0 15px;
}
.menu-actions {
  display: flex;
  justify-content: space-around;
  padding: 15px 10px;
}
.menu-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
  cursor: pointer;
}
.menu-icon {
  width: 32px;
  height: 32px;
}
.menu-item span {
  font-size: 12px;
  color: #333;
}
.menu-logout {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  padding: 12px;
  border-top: 1px solid #eee;
  cursor: pointer;
  color: #666;
  font-size: 13px;
}
.menu-logout:hover {
  background: #f5f5f5;
}
.logout-icon {
  width: 16px;
  height: 16px;
}
.login-btn {
  padding: 8px 24px;
  background: #3d8c40;
  color: #fff;
  border: none;
  border-radius: 20px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
}
.login-btn:hover {
  background: #2e7d32;
}
@media screen and (max-width: 768px) {
  .header-content {
    padding: 12px 15px;
  }
  .logo {
    font-size: 18px;
  }
  .avatar {
    width: 28px;
    height: 28px;
  }
  .user-email {
    display: none;
  }
  .user-menu {
    width: 260px;
    right: -10px;
  }
}
</style>
